const START_DISTANCE_THRESHOLD = 0.25;
const END_DISTANCE_THRESHOLD = 0.75;

export interface LinkLabelsDictionary {
  attribute: number;
  offset: number;
}

export class AttributePositionLogic {
  static getLabelPositions(linkView: joint.dia.LinkView): LinkLabelsDictionary {
    const linkLength = linkView.getConnectionLength();
    const labels = linkView.model.attributes.labels;
    const newLabelsDictionary: LinkLabelsDictionary = {
      attribute: 0.5,
      offset: 0.9,
    };

    labels.forEach((el, index) => {
      const coords = linkView.getLabelCoordinates(el.position);
      const percentagePosition = linkView.getLabelPosition(coords.x, coords.y);
      const absolutePosition = linkView.getLabelPosition(coords.x, coords.y, { absoluteDistance: true });

      if (
        absolutePosition.distance > START_DISTANCE_THRESHOLD * linkLength &&
        absolutePosition.distance < END_DISTANCE_THRESHOLD * linkLength
      ) {
        linkView.model.label(index, {
          position: percentagePosition.distance,
        });
        this.setLabelsDictionary(newLabelsDictionary, index, percentagePosition.distance);
      } else {
        const adjustedPosition =
          absolutePosition.distance > linkLength / 2 ? absolutePosition.distance - linkLength : absolutePosition.distance;
        linkView.model.label(index, {
          position: adjustedPosition,
        });
        this.setLabelsDictionary(newLabelsDictionary, index, adjustedPosition);
      }
    });

    return newLabelsDictionary;
  }

  static setLabelsDictionary(labelsDictionary: LinkLabelsDictionary, index: number, value: number) {
    switch (index) {
      case 0:
        labelsDictionary.attribute = value;
        break;
      case 1:
        labelsDictionary.offset = value;
        break;
      default:
        break;
    }
  }
}
